<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="用户标签" prop="tag">
        <Input v-model="formValidate.tag" placeholder="请输入用户标签"></Input>
      </FormItem>

      <FormItem label="标签描述" prop="tag_desc">
        <Input v-model="formValidate.tag_desc" placeholder="请输入标签描述" type="textarea"></Input>
      </FormItem>

      <FormItem label="浏览间隔小时" prop="interval_browse_hour">
        <Input v-model="formValidate.interval_browse_hour" placeholder="请输入间隔小时" type="number"></Input>
      </FormItem>

      <FormItem label="平台"  prop="live_id">
        <Select v-model="formValidate.live_id">
          <Option
            v-for="item in liveTypes"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="所属分类"  prop="classify_id" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="类型">
        <RadioGroup v-model="formValidate.type">
        <Radio label="kol"></Radio>
        <Radio label="store"></Radio>
        <Radio label="other"></Radio>
        <Radio label="black"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      liveTypes:[],
      formValidate: {
        id: '',
        tag: '',
        classify_id:0,
        tag_desc:'',
        type:'black',
        interval_browse_hour:'',
        live_id:''
      },
      ruleValidate: {
        tag: [
          {
            required: true,
            message: '标签不能为空',
            trigger: 'blur'
          }
        ],tag_desc: [
          {
            required: true,
            message: '标签描述不能为空',
            trigger: 'blur'
          }
        ],
        classify_id: [
          {
            required: true,
            message: '所属分类必须要选择',
            trigger: 'change'
          }
        ],live_id: [
          {
            required: true,
            message: '平台必须要选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },setLiveType (live_type_list) {
      var data = new Array()
      for (var i = 0; i < live_type_list.length; i++) {
        data[i] = { id: live_type_list[i].id.toString(), name: live_type_list[i].name }
      }
      this.liveTypes = data
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.classify_id = data.dy_classify_id.toString()
      this.formValidate.live_id = data.live_id.toString()
      this.formValidate.tag = data.tag
      this.formValidate.tag_desc = data.tag_desc
      this.formValidate.type = data.type
      this.formValidate.interval_browse_hour = data.interval_browse_hour.toString()
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
